import React, { useState, useEffect, useRef } from 'react';
import { resolveMediaUrl } from '../utils/mediaUrl';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
const SLIDE_MS = 5000;

const HeroGallerySlider = () => {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const slidesKeyRef = useRef('');

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/social-feed/hero`)
      .then((res) => (res.ok ? res.json() : { items: [] }))
      .then((data) => {
        if (cancelled) return;
        const items = Array.isArray(data.items)
          ? data.items.filter((item) => item.imageUrl)
          : [];
        const key = items.map((i) => i.id).join(',');
        if (key !== slidesKeyRef.current) {
          slidesKeyRef.current = key;
          setActiveIndex(0);
        }
        setSlides(items);
      })
      .catch(() => {
        if (!cancelled) setSlides([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, SLIDE_MS);
    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    if (slides.length <= 1) return;
    const next = slides[(activeIndex + 1) % slides.length];
    if (!next?.imageUrl) return;
    const img = new Image();
    img.src = resolveMediaUrl(next.imageUrl);
  }, [activeIndex, slides]);

  if (!slides.length) return null;

  return (
    <div className="hero-gallery-slider" aria-hidden>
      {slides.map((slide, index) => (
        <img
          key={slide.id}
          src={resolveMediaUrl(slide.imageUrl)}
          alt=""
          className={`hero-gallery-slide${index === activeIndex ? ' hero-gallery-slide--active' : ''}`}
          loading={index === 0 ? 'eager' : 'lazy'}
          decoding="async"
        />
      ))}
    </div>
  );
};

export default HeroGallerySlider;
